/**
 * @generated SignedSource<<71a503ba3570022dba8099e4de6db654>>
 * @relayHash 9c9bbc69c5cf739bf4e85ea526db9ad0
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3fa6215034e680525e0472a1152411608671dd7db449ac7fd9eec337ef0c2c0b

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFormattingArea = "CELL" | "ROW" | "%future added value";
export type JiraFormattingMultipleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "HAS_ANY_OF" | "%future added value";
export type JiraFormattingNoValueOperator = "IS_EMPTY" | "IS_NOT_EMPTY" | "%future added value";
export type JiraFormattingSingleValueOperator = "CONTAINS" | "DOES_NOT_CONTAIN" | "DOES_NOT_EQUAL" | "EQUALS" | "GREATER_THAN" | "GREATER_THAN_OR_EQUALS" | "IS" | "IS_AFTER" | "IS_BEFORE" | "IS_NOT" | "IS_ON_OR_AFTER" | "IS_ON_OR_BEFORE" | "LESS_THAN" | "LESS_THAN_OR_EQUALS" | "%future added value";
export type JiraIssueSearchAggregationFunction = "ROLLUP" | "%future added value";
export type JiraSoftwareIssueSearchCustomInputContext = "BACKLOG" | "BOARD" | "NONE" | "%future added value";
export type JiraIssueSearchInput = {
  childIssuesInput?: JiraIssueSearchChildIssuesInput | null | undefined;
  customInput?: JiraIssueSearchCustomInput | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  searchWithLastUsedJql?: boolean | null | undefined;
};
export type JiraIssueSearchChildIssuesInput = {
  filterByProjectKeys?: ReadonlyArray<string> | null | undefined;
  filterId?: string | null | undefined;
  jql?: string | null | undefined;
  namespace?: string | null | undefined;
  parentIssueKey: string;
  viewId?: string | null | undefined;
};
export type JiraIssueSearchCustomInput = {
  jiraSoftwareInput?: JiraSoftwareIssueSearchCustomInput | null | undefined;
};
export type JiraSoftwareIssueSearchCustomInput = {
  additionalJql?: string | null | undefined;
  context?: JiraSoftwareIssueSearchCustomInputContext | null | undefined;
  jiraEntityId: string;
};
export type JiraIssueSearchStaticViewInput = {
  aggregationConfig?: JiraIssueSearchAggregationConfigInput | null | undefined;
  isGroupingEnabled?: boolean | null | undefined;
  isHideDoneEnabled?: boolean | null | undefined;
  isHierarchyEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchAggregationConfigInput = {
  aggregationFields?: ReadonlyArray<JiraIssueSearchFieldAggregationInput> | null | undefined;
  canEnableAggregation?: boolean | null | undefined;
};
export type JiraIssueSearchFieldAggregationInput = {
  aggregationFunction?: JiraIssueSearchAggregationFunction | null | undefined;
  fieldId?: string | null | undefined;
  isEnabled?: boolean | null | undefined;
};
export type JiraIssueSearchViewQueryInput = {
  projectKeyAndItemIdQuery?: JiraIssueSearchViewProjectKeyAndItemIdQuery | null | undefined;
  viewAri?: string | null | undefined;
};
export type JiraIssueSearchViewProjectKeyAndItemIdQuery = {
  cloudId: string;
  itemId: string;
  projectKey: string;
};
export type FormatRulesNewQuery$variables = {
  cloudId: string;
  filterId?: string | null | undefined;
  first: number;
  issueSearchInput: JiraIssueSearchInput;
  namespace?: string | null | undefined;
  staticViewInput?: JiraIssueSearchStaticViewInput | null | undefined;
  viewId?: string | null | undefined;
  viewQueryInput?: JiraIssueSearchViewQueryInput | null | undefined;
};
export type FormatRulesNewQuery$data = {
  readonly jira: {
    readonly jiraIssueSearchView: {
      readonly conditionalFormattingRules?: {
        readonly edges: ReadonlyArray<{
          readonly node: {
            readonly expression: {
              readonly __typename: "JiraFormattingMultipleValueOperand";
              readonly fieldId: string;
              readonly multipleValueOperator: JiraFormattingMultipleValueOperator;
              readonly values: ReadonlyArray<string>;
            } | {
              readonly __typename: "JiraFormattingNoValueOperand";
              readonly fieldId: string;
              readonly noValueOperator: JiraFormattingNoValueOperator;
            } | {
              readonly __typename: "JiraFormattingSingleValueOperand";
              readonly fieldId: string;
              readonly singleValueOperator: JiraFormattingSingleValueOperator;
              readonly value: string;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            };
            readonly formattingArea: JiraFormattingArea;
            readonly formattingColor: {
              readonly colorKey: string | null | undefined;
            };
            readonly id: string;
          } | null | undefined;
        } | null | undefined> | null | undefined;
      } | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"FormatRulesNew_view">;
    } | null | undefined;
  } | null | undefined;
};
export type FormatRulesNewQuery = {
  response: FormatRulesNewQuery$data;
  variables: FormatRulesNewQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filterId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueSearchInput"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "namespace"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "staticViewInput"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewId"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "viewQueryInput"
},
v8 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Variable",
    "name": "filterId",
    "variableName": "filterId"
  },
  {
    "kind": "Variable",
    "name": "issueSearchInput",
    "variableName": "issueSearchInput"
  },
  {
    "kind": "Variable",
    "name": "namespace",
    "variableName": "namespace"
  },
  {
    "kind": "Variable",
    "name": "viewConfigInput",
    "variableName": "staticViewInput"
  },
  {
    "kind": "Variable",
    "name": "viewId",
    "variableName": "viewId"
  },
  {
    "kind": "Variable",
    "name": "viewQueryInput",
    "variableName": "viewQueryInput"
  }
],
v9 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  }
],
v10 = {
  "kind": "ScalarField",
  "name": "id"
},
v11 = {
  "kind": "ScalarField",
  "name": "colorKey"
},
v12 = {
  "kind": "ScalarField",
  "name": "formattingArea"
},
v13 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v14 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v15 = {
  "kind": "LinkedField",
  "name": "expression",
  "plural": false,
  "selections": [
    (v13/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/),
        {
          "alias": "singleValueOperator",
          "kind": "ScalarField",
          "name": "operator"
        },
        {
          "kind": "ScalarField",
          "name": "value"
        }
      ],
      "type": "JiraFormattingSingleValueOperand"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/),
        {
          "alias": "multipleValueOperator",
          "kind": "ScalarField",
          "name": "operator"
        },
        {
          "kind": "ScalarField",
          "name": "values"
        }
      ],
      "type": "JiraFormattingMultipleValueOperand"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        (v14/*: any*/),
        {
          "alias": "noValueOperator",
          "kind": "ScalarField",
          "name": "operator"
        }
      ],
      "type": "JiraFormattingNoValueOperand"
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Fragment",
    "name": "FormatRulesNewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "jiraIssueSearchView",
            "plural": false,
            "selections": [
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v9/*: any*/),
                    "kind": "FragmentSpread",
                    "name": "FormatRulesNew_view"
                  },
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "JiraFormattingRuleConnection",
                    "kind": "LinkedField",
                    "name": "conditionalFormattingRules",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFormattingRule",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "formattingColor",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/)
                                ]
                              },
                              (v12/*: any*/),
                              (v15/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
              }
            ]
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v3/*: any*/),
      (v5/*: any*/),
      (v1/*: any*/),
      (v7/*: any*/)
    ],
    "kind": "Operation",
    "name": "FormatRulesNewQuery",
    "selections": [
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v8/*: any*/),
            "kind": "LinkedField",
            "name": "jiraIssueSearchView",
            "plural": false,
            "selections": [
              (v13/*: any*/),
              {
                "kind": "InlineFragment",
                "selections": [
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "JiraFormattingRuleConnection",
                    "kind": "LinkedField",
                    "name": "conditionalFormattingRules",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "JiraFormattingRuleEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "JiraFormattingRule",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v10/*: any*/),
                              {
                                "concreteType": "JiraColor",
                                "kind": "LinkedField",
                                "name": "formattingColor",
                                "plural": false,
                                "selections": [
                                  (v11/*: any*/),
                                  (v10/*: any*/)
                                ]
                              },
                              (v12/*: any*/),
                              (v15/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ],
                "type": "JiraSpreadsheetView",
                "abstractKey": "__isJiraSpreadsheetView"
              },
              (v10/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "3fa6215034e680525e0472a1152411608671dd7db449ac7fd9eec337ef0c2c0b",
    "metadata": {},
    "name": "FormatRulesNewQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "f94605784c72f35fe3aba24136d4be36";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
